/**
 * Survey durable-mutation type strings — one per survey callable the offline
 * queue replays. Kept in a dependency-free leaf module so both the enqueue API
 * (surveyMutations.ts) and the sync handlers (surveySyncHandlers.ts) can import
 * it without forming an import cycle through offlineEngine.ts.
 */
export const SURVEY_MUTATION = {
  create: 'survey.create',
  updateSection: 'survey.updateSection',
  updateNoteCards: 'survey.updateNoteCards',
  markSectionComplete: 'survey.markSectionComplete',
  updateStatus: 'survey.updateStatus',
  setLocation: 'survey.setLocation',
  saveMap: 'survey.saveMap',
  addContact: 'survey.addContact',
  addIntakePhoto: 'survey.addIntakePhoto',
  addPhoto: 'survey.addPhoto',
  removePhoto: 'survey.removePhoto',
} as const;

export type SurveyMutationType = (typeof SURVEY_MUTATION)[keyof typeof SURVEY_MUTATION];
